import { unwrapResult } from '@reduxjs/toolkit';
import { logError } from '@ff-os/shared-utils/logging';
import { fireOrderEventToSite } from '../global-state/site-events';
import { AsyncPdpThunk } from '../store';
import { pushProject } from './projects/pushProject';

export const submitOrder = (quantity: number = 1): AsyncPdpThunk => {
    return async (dispatch, getState) => {
        try {
            const result = unwrapResult(await dispatch(pushProject()));
            const state = getState();
            await retry({ max: 10 }, () => fireOrderEventToSite({
                name: 'order',
                quantity: quantity,
                projectId: state.auth.secret!,
                snapshotId: result.snapshotId
            }));
        } catch (e) {
            logError(e);
            throw e;
        }
    };
};

const retry = async (
    options: { max: number; backoff?: number },
    run: () => Promise<void>
): Promise<void> => {

    const max = options.max;
    const backoff = options.backoff ?? 1000;

    const attempt = async (n: number) => {
        try {
            await run();
        } catch (e) {
            if (n < max) {
                await delay(n * backoff, () => attempt(n + 1));
            } else {
                throw e;
            }
        }
    };

    await attempt(1);
};

const delay = async <T>(ms: number, run: () => Promise<T>): Promise<T> => {
    return new Promise((resolve, reject) => {
        setTimeout(() => {
            run().then(resolve).catch(reject);
        }, ms);
    });
};